// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1yZAh","productName":"Table_productName__1gVlU"};